import {IConsentMgmtForm} from "../../models/models";
import * as yup from "yup";

export const CONSENT_MGMT_INITIAL_VALUE: IConsentMgmtForm = {
    consents: {
        extendedPromotionsAgree: false,
        extendedPromotionsDisagree: false,
        relatedPromotionsAgree: false,
        relatedPromotionsDisagree: false,
        commercialPromotionsAgree: false,
        commercialPromotionsDisagree: false,
        file: null
    },
    acknowledgment: false
}

export const CONSENT_MGMT_VALIDATION_SCHEMA = yup.object().shape({
    consents:  yup.object().shape({
        extendedPromotionsAgree: yup.boolean()
            .test({
                name: 'extendedPromotionsAgree',
                message: "common.error.required",
                test(value, context) {
                    return !!value || !!context.parent.extendedPromotionsDisagree;
                }
            }),
        extendedPromotionsDisagree: yup.boolean()
            .test({
                name: 'extendedPromotionsDisagree',
                message: "common.error.required",
                test(value, context) {
                    return !!value || !!context.parent.extendedPromotionsAgree;
                }
            }),
        relatedPromotionsAgree: yup.boolean()
            .test({
                name: 'relatedPromotionsAgree',
                message: "common.error.required",
                test(value, context) {
                    return !!value || !!context.parent.relatedPromotionsDisagree;
                }
            }),
        relatedPromotionsDisagree: yup.boolean()
            .test({
                name: 'relatedPromotionsDisagree',
                message: "common.error.required",
                test(value, context) {
                    return !!value || !!context.parent.relatedPromotionsAgree;
                }
            }),
        commercialPromotionsAgree: yup.boolean()
            .test({
                name: 'commercialPromotionsAgree',
                message: "common.error.required",
                test(value, context) {
                    return !!value || !!context.parent.commercialPromotionsDisagree;
                }
            }),
        commercialPromotionsDisagree: yup.boolean()
            .test({
                name: 'commercialPromotionsDisagree',
                message: "common.error.required",
                test(value, context) {
                    return !!value || !!context.parent.commercialPromotionsAgree;
                }
            }),
        file: yup
            .mixed()
            .nullable()
            .required("common.error.required")
    }),
    acknowledgment: yup.boolean()
        .test({
            name: 'acknowledgment',
            message: "common.error.required",
            test(value) {
                return !!value;
            }
        })
});
